import { NavigateFunction, createSearchParams } from 'react-router-dom'
import { Product } from '../../../storage'
import { ProductType } from '../../ProductCard'
export const openProductDetailsLink = (
  item: Product,
  isAllProduct: boolean,
  productType: ProductType,
  navigate: NavigateFunction,
) => {
  const params = createSearchParams({
    size: item?.sizeDescription ?? '',
    colour: item?.colourDescription ?? '',
  })

  navigate(
    {
      pathname: `/products/${item.masterProductId}`,
      search: params.toString(),
    },
    {
      state: {
        category: item.category,
        subCategory: item.subCategory,
        isPriceNegotiable: item.isPriceNegotiable,
        productTab: isAllProduct ? 1 : 0,
        lifeCycleState: item.lifeCycleState,
        productType,
      },
    },
  )
}
